<template>
    <div>
        사용자정보   
        <p v-if="name">{{name}}</p>    
        <p v-if="email">{{email}}</p>    
        <p v-if="phoneCompany">{{phoneCompany}}</p>    
        <p v-if="phoneNumber">{{phoneNumber}}</p>    
        <p v-if="address">{{address}}</p>    
        <p v-if="addressDetail">{{addressDetail}}</p>
    </div>
    
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            name : null,
            email : null,
            phoneCompany : null,
            phoneNumber : null,
            address : null,
            addressDetail : null
        }
    },
    methods: {
        getUserInfo(){
            let paramDatas = this.$store.state.modal.paramDatas;
            axios.post('http://localhost:8080/test/getUserByIdx', paramDatas.idx)
            .then(response => {
                if(response.status == 200){
                    let userData = response.data.USER;
                    this.name = userData.name;
                    this.phoneCompany = userData.phoneCompany;
                    this.phoneNumber = userData.phoneNumber;
                    this.address = userData.address;
                    this.addressDetail = userData.addressDetail;
                }
            })
            .catch(() => {
            })
            .then(() => {
            });
        },
        doOkFunc(){
            console.log("hi")
        }
    },
    mounted: function(){
        this.getUserInfo();
    }
}
</script>